import React, { Component } from 'react';
import '../App.css';
import { observer, inject } from 'mobx-react';
import Survey1 from './Survey1';
import Survey2 from './Survey2';
import DefaultResult from './DefaultResult';

function Display(props) {
  if (props.route === 'default') {
    return <DefaultResult />;
  } else if (props.route === 'survey1') {
    return <Survey1 />;
  } else {
    return <Survey2 />;
  }
}

class Results extends Component {
  render() {
    return <Display route={this.props.StateStore.resultRoute} />;
  }
}

export default inject('StateStore')(observer(Results));
